/* eslint-disable import/no-default-export */
import {ThankYouPageController} from './ThankYouPageController';
import {controllerFactory as oldControllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/controller-factory/controllerFactory';
import {conditionalController} from './conditionalController';
import {ControllerConstructorType, controllerFactory} from './controllerFactory';
import {Specs} from './constants';

export const conditionalControllerFactory = (controller: ControllerConstructorType<ThankYouPageController>) =>
  conditionalController(
    Specs.UseNewControllerFactoryInTYP,
    controllerFactory(controller),
    oldControllerFactory(controller, {shouldCallAppSettingsOnlyWhenMultilingualIsNeeded: true})
  );

export default conditionalControllerFactory(ThankYouPageController);
